export default __webpack_public_path__ + "static/usa_south_carolina_palmetto_cash_5-79baf204e348347da7ebd62da325d371.png";